var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.forDisplay)?_c('SectionTitle',{attrs:{"title":_vm.title}}):_vm._e(),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('select-field',{ref:"where_know",attrs:{"title":"このサービスをどこで知りましたか？","required":true,"hasOther":"true","max-length":"200","options":[
          { title: '新聞・雑誌・テレビ等', value: '新聞・雑誌・テレビ等' },
          {
            title: 'Yahoo!やGoogleなどの検索エンジン',
            value: 'Yahoo!やGoogleなどの検索エンジン',
          },
          { title: '知人のSNS投稿', value: '知人のSNS投稿' },
          {
            title: '当社や当サービスのFacebookページ',
            value: '当社や当サービスのFacebookページ',
          },
          { title: 'Silent Voiceの講演会', value: 'Silent Voiceの講演会' },
          { title: '知人の紹介', value: '知人の紹介' },
          {
            title: '弊社スタッフからの紹介',
            value: '弊社スタッフからの紹介',
          } ],"forDisplay":_vm.forDisplay},model:{value:(_vm.model.where_know),callback:function ($$v) {_vm.$set(_vm.model, "where_know", $$v)},expression:"model.where_know"}})],1)]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('check-box-group',{ref:"why_application",attrs:{"title":"なぜ申し込みをしようと思いましたか？あてはまるものすべて選択してください。（複数選択可）","required":true,"limit":"3","forDisplay":_vm.forDisplay,"options":[
          { title: '評判がいいから', value: '評判がいいから' },
          {
            title: '評判の良い先生がいるから',
            value: '評判の良い先生がいるから',
          },
          { title: '教材が魅力的だから', value: '教材が魅力的だから' },
          { title: '授業料が安いから', value: '授業料が安いから' },
          {
            title: 'オンラインは便利だから',
            value: 'オンラインは便利だから',
          },
          { title: '移動がなく安心だから', value: '移動がなく安心だから' },
          {
            title: '人との接触がなく安全だから',
            value: '人との接触がなく安全だから',
          },
          {
            title: '友だちが使っているから',
            value: '友だちが使っているから',
          },
          { title: '留学に興味があるから', value: '留学に興味があるから' },
          { title: '手話を覚えたいから', value: '手話を覚えたいから' },
          {
            title: '体験授業を受けたかったから',
            value: '体験授業を受けたかったから',
          },
          {
            title: '周囲に子どものニーズに合った塾や習い事がないから',
            value: '周囲に子どものニーズに合った塾や習い事がないから',
          },
          {
            title: '子どもが孤立しているから',
            value: '子どもが孤立しているから',
          } ]},model:{value:(_vm.model.why_application),callback:function ($$v) {_vm.$set(_vm.model, "why_application", $$v)},expression:"model.why_application"}})],1)]),(_vm.isCO)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('text-area',{ref:"reason_application",attrs:{"title":"なぜ申し込みをされましたか？可能であれば、困り感や期待することなどを具体的に教えてください。","type":"text","required":true,"max-length":500,"forDisplay":_vm.forDisplay},model:{value:(_vm.model.reason_application),callback:function ($$v) {_vm.$set(_vm.model, "reason_application", $$v)},expression:"model.reason_application"}})],1)]):_vm._e(),_c('ErrorSummary',{attrs:{"error_summary":_vm.error_summary}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }